export const CIPP_CALCULATOR = 'CIPP_CALCULATOR'
export const CIPP_CALCULATOR_SUCCESS = 'CIPP_CALCULATOR_SUCCESS'
export const CIPP_CALCULATOR_FAILURE = 'CIPP_CALCULATOR_FAILURE'
